




















import { Component, Prop, Vue } from 'vue-property-decorator'
import AppDialog from '@core/components/AppDialog.vue'
import AppForm from '@core/components/AppForm.vue'
import { HierarchySetupDTO, HierarchySetupService } from '../api'
import { FormStructure } from '@master/model/structure/FormStructure'

@Component({
  components: {
    AppDialog,
    AppForm
  }
})
export default class HierarchyRowView extends Vue {
  @Prop() selectedRow: HierarchySetupDTO
  @Prop() tierOneStructure: FormStructure<HierarchySetupDTO>
  @Prop() tierTwoStructure: FormStructure<HierarchySetupDTO>
  @Prop() tierThreeStructure: FormStructure<HierarchySetupDTO>
  @Prop() performanceServiceStructure: FormStructure<HierarchySetupDTO>
  @Prop() repStructure: FormStructure<HierarchySetupDTO>
}
